/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreatePassengerTypeRequest } from '../models/create-passenger-type-request';
import { GenericResponse } from '../models/generic-response';
import { GetPassengerTypeResponse } from '../models/get-passenger-type-response';
import { PassengerTypeResponse } from '../models/passenger-type-response';
import { UpdatePassengerTypeRequest } from '../models/update-passenger-type-request';

/**
 * passenger type apis
 */
@Injectable({ providedIn: 'root' })
export class PassengerTypeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllPassengerType()` */
  static readonly GetAllPassengerTypePath = '/api/v1/passenger-types';

  /**
   * Get list of passenger type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllPassengerType()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPassengerType$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - type
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetPassengerTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      PassengerTypeService.GetAllPassengerTypePath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetPassengerTypeResponse>;
        })
      );
  }

  /**
   * Get list of passenger type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllPassengerType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPassengerType(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - type
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetPassengerTypeResponse> {
    return this.getAllPassengerType$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetPassengerTypeResponse>
        ): GetPassengerTypeResponse => r.body
      )
    );
  }

  /** Path part for operation `createPassengerType()` */
  static readonly CreatePassengerTypePath = '/api/v1/passenger-types';

  /**
   * Create new passenger type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPassengerType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPassengerType$Response(
    params: {
      body: CreatePassengerTypeRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PassengerTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      PassengerTypeService.CreatePassengerTypePath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<PassengerTypeResponse>;
        })
      );
  }

  /**
   * Create new passenger type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPassengerType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPassengerType(
    params: {
      body: CreatePassengerTypeRequest;
    },
    context?: HttpContext
  ): Observable<PassengerTypeResponse> {
    return this.createPassengerType$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<PassengerTypeResponse>): PassengerTypeResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `deletePassengerType()` */
  static readonly DeletePassengerTypePath = '/api/v1/passenger-types/{id}';

  /**
   * Delete passenger type by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePassengerType()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePassengerType$Response(
    params: {
      /**
       * The passenger type's id that needs to be deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      PassengerTypeService.DeletePassengerTypePath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Delete passenger type by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePassengerType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePassengerType(
    params: {
      /**
       * The passenger type's id that needs to be deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.deletePassengerType$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updatePassengerType()` */
  static readonly UpdatePassengerTypePath = '/api/v1/passenger-types/{id}';

  /**
   * Update passenger type by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePassengerType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePassengerType$Response(
    params: {
      /**
       * The passenger type's id that needs to be updated
       */
      id: number;
      body: UpdatePassengerTypeRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PassengerTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      PassengerTypeService.UpdatePassengerTypePath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<PassengerTypeResponse>;
        })
      );
  }

  /**
   * Update passenger type by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePassengerType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePassengerType(
    params: {
      /**
       * The passenger type's id that needs to be updated
       */
      id: number;
      body: UpdatePassengerTypeRequest;
    },
    context?: HttpContext
  ): Observable<PassengerTypeResponse> {
    return this.updatePassengerType$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<PassengerTypeResponse>): PassengerTypeResponse =>
          r.body
      )
    );
  }
}
